var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4668 10.7727V9.22733L14.7441 8.651C14.6136 8.15839 14.4176 7.68551 14.1614 7.245L14.9721 5.62367L13.8764 4.528L12.2551 5.33867C11.8146 5.08247 11.3417 4.8865 10.8491 4.756L10.2728 3.03333H8.72745L8.15111 4.756C7.65851 4.8865 7.18563 5.08247 6.74511 5.33867L5.12378 4.528L4.02811 5.62367L4.83878 7.245C4.58258 7.68551 4.38661 8.15839 4.25611 8.651L2.53345 9.22733V10.7727L4.25611 11.349C4.38661 11.8416 4.58258 12.3145 4.83878 12.755L4.02811 14.3763L5.12378 15.472L6.74511 14.6613C7.18563 14.9175 7.65851 15.1135 8.15111 15.244L8.72745 16.9667H10.2728L10.8491 15.244C11.3417 15.1135 11.8146 14.9175 12.2551 14.6613L13.8764 15.472L14.9721 14.3763L14.1614 12.755C14.4176 12.3145 14.6136 11.8416 14.7441 11.349L16.4668 10.7727Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49989 12.5333C10.899 12.5333 12.0332 11.3991 12.0332 10C12.0332 8.60088 10.899 7.46667 9.49989 7.46667C8.10076 7.46667 6.96655 8.60088 6.96655 10C6.96655 11.3991 8.10076 12.5333 9.49989 12.5333Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settings-icon.60fc8d5a12224e8847ca712c25c92a0d.svg";
export { ForwardRef as ReactComponent };